import axios from "axios";
import apiClientConf from "../../config/apiClientConf";
import Tokens from "csrf";
class ApiClient {

    /**
     * 생성자: axios 인스턴스 생성 및 CSRF 토큰 관리 객체 초기화
     */
    constructor () {

        this.instance = axios.create( apiClientConf.common );
        this.tokens = new Tokens();
        this._csrfToken = null;
    }

     /**
     * CSRF 토큰을 헤더에 붙이는 내부 메서드
     * @param {object} options - axios 요청 옵션 객체
     * @returns {object} CSRF 토큰이 포함된 axios 요청 옵션
     */
    _attachCSRF(options = {}) {

        const secret = localStorage.getItem("csrfSecret");
        
        if (secret) {
            
            this._csrfToken = this.tokens.create(secret);
        }

        return {
            ...options,
            headers: {
                ...options.headers,
                _csrf: this._csrfToken,
            },
        };
    }


    get ( url, options ) {

        options = {
            ...apiClientConf.commonOptions,
            ...apiClientConf.methodOptions.get,
            ...options,
        }

        options = this._attachCSRF(options);

        return this.instance.get ( url, options );

    }

    post ( url, data, options ) {

        options = {
            ...apiClientConf.commonOptions,
            ...apiClientConf.methodOptions.post,
            ...options,
        }

        options = this._attachCSRF(options);

        return this.instance.post ( url, data, options );

    }

    put ( url, data, options ) {

        options = {
            ...apiClientConf.commonOptions,
            ...apiClientConf.methodOptions.put,
            ...options,
        }

        options = this._attachCSRF(options);

        return this.instance.put ( url, data, options );

    }

    patch ( url, data, options ) {

        options = {
            ...apiClientConf.commonOptions,
            ...apiClientConf.methodOptions.patch,
            ...options,
        }

        options = this._attachCSRF(options);

        return this.instance.patch ( url, data, options );

    }

    del ( url, options ) {

        options = {
            ...apiClientConf.commonOptions,
            ...apiClientConf.methodOptions.delete,
            ...options,
        }

        options = this._attachCSRF(options);

        return this.instance.delete ( url, options );

    }

    bulkDel ( url, data, options ) {

        options = {
            ...apiClientConf.commonOptions,
            ...apiClientConf.methodOptions.delete,
            ...options,
        }

        options = this._attachCSRF(options);

        return this.instance.request ( { url, ...options, data, method: "delete" } );

    }

}

export default new ApiClient();
